import * as React from 'react';

import PropTypes from 'prop-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import user from 'js/lib/user';

import { Button } from '@coursera/cds-core';

import AccountDeletionModal from 'bundles/account-settings/components/sections/delete-account/AccountDeletionModal';
import Naptime from 'bundles/naptimejs';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import DegreeLearnerMembershipsV1 from 'bundles/naptimejs/resources/degreeLearnerMemberships.v1';
import AccountLinkStore from 'bundles/third-party-auth/stores/AccountLinkStore';

import _t from 'i18n!nls/account-settings';

class AccountDeletion extends React.Component {
  static propTypes = {
    userId: PropTypes.number,
    ...AccountLinkStore.SHAPE,
  };

  state = {
    showAccountDeletionModal: false,
    showDelinkError: false,
    linkedAccount: null,
  };

  handleOpenModal = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'linked' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (this.props.linked.facebook) {
      this.setState(() => ({
        showDelinkError: true,
        linkedAccount: 'facebook',
      }));
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'linked' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.linked.apple) {
      this.setState(() => ({
        showDelinkError: true,
        linkedAccount: 'apple',
      }));
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'linked' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.linked.google) {
      this.setState(() => ({
        showDelinkError: true,
        linkedAccount: 'google',
      }));
    } else {
      this.setState({
        showAccountDeletionModal: true,
        showDelinkError: false,
      });
    }
  };

  getLinkedAccountErrorMessage = () => {
    const { linkedAccount } = this.state;

    let message = null;
    if (linkedAccount === 'facebook') {
      message = _t('Please unlink your Facebook account first.');
    } else if (linkedAccount === 'apple') {
      message = _t('Please unlink your Apple account first.');
    } else if (linkedAccount === 'google') {
      message = _t('Please unlink your Google account first.');
    }
    return message;
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'degreeMemberships' does not exist on typ... Remove this comment to see the full error message
    const { degreeMemberships } = this.props;
    const degreeMembershipLength = degreeMemberships.length;
    // Partner guidelines say that degree learners should not be allowed to delete their account.
    if (degreeMembershipLength > 0) {
      return (
        <div className="rc-AccountDeletion">
          <h2 className="display-2-text section-title">{_t('Delete Account')}</h2>
          <p>
            {_t(
              `In accordance with higher education regulations, the delete function has been disabled for learners in credit-eligible and for-credit offerings.`
            )}
          </p>
        </div>
      );
    }
    return (
      <div className="rc-AccountDeletion">
        {this.state.showAccountDeletionModal && (
          <AccountDeletionModal
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ userId: any; onClose: () => void; }' is no... Remove this comment to see the full error message
            userId={this.props.userId}
            onClose={() => {
              this.setState({ showAccountDeletionModal: false });
            }}
          />
        )}
        <h2 className="display-2-text section-title">{_t('Delete Account')}</h2>
        <div>
          <p>
            {_t(
              `
              If you delete your account, your personal information will be wiped from Coursera's servers,
              all of your course activity will be anonymized and any certificates earned will be deleted.
              This action cannot be undone! `
            )}
            <span className="section-body-warning">
              {_t('Cancel any active subscriptions before you delete your account.')}
            </span>
          </p>

          <Button type="button" variant="secondary" onClick={this.handleOpenModal}>
            {_t('Delete Account')}
          </Button>

          {this.state.showDelinkError && this.state.linkedAccount && (
            <div className="rc-StatusMessage error">{this.getLinkedAccountErrorMessage()}</div>
          )}
        </div>
      </div>
    );
  }
}

// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
const connectAccountDeletion = connectToStores(AccountDeletion, [AccountLinkStore], (storeInstances, props) => {
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  return storeInstances[AccountLinkStore.storeName].dehydrate();
});

export default Naptime.createContainer((props) => ({
  degreeMemberships: DegreeLearnerMembershipsV1.finder('byUser', {
    params: {
      userId: user.get().id,
    },
    fields: ['degreeId'],
  }),
}))(connectAccountDeletion);
